/*
 * Cart upsell sliders: floating "<" / ">" scroll arrows (Leverandører style)
 * instead of the theme's prev/next + "1/11" counter.
 *   - ">" shows while there's more to the right; click scrolls ~one page right.
 *   - "<" pops up once you've scrolled away from the start; click scrolls left.
 * Each appears only when relevant (and only when the row overflows).
 */
(function () {
  function init(root) {
    (root || document).querySelectorAll('.cart-upsell__slider').forEach(function (sc) {
      if (sc.dataset.arrowInit) return;
      sc.dataset.arrowInit = '1';

      var scroller = sc.querySelector('ul');
      if (!scroller) return;
      var prev = sc.querySelector('.cart-upsell__arrow--prev');
      var next = sc.querySelector('.cart-upsell__arrow--next');

      function page(dir) {
        scroller.scrollBy({ left: dir * Math.round(scroller.clientWidth * 0.85), behavior: 'smooth' });
      }

      function update() {
        var canScroll = scroller.scrollWidth - scroller.clientWidth > 2;
        var atStart = scroller.scrollLeft <= 2;
        var atEnd = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 2;
        sc.classList.toggle('show-prev', canScroll && !atStart);
        sc.classList.toggle('show-next', canScroll && !atEnd);
      }

      if (prev) prev.addEventListener('click', function () { page(-1); });
      if (next) next.addEventListener('click', function () { page(1); });
      scroller.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
